import emitAsync from '../utils/emitAsync';
import { useLoadingStore } from '../stores/useLoadingStore';

// =========================
// REQUESTS ATIVAS
// =========================

const activeRequests = new Set();

// =========================
// LOADING
// =========================

const {
  setLoadingDrivers,
  setLoadingFooter,
  setLoadingFooterTxt,
  setLoadProgress
} = useLoadingStore.getState();

// =========================
// LOAD DRIVERS
// =========================

export async function loadDrivers(socket) {

  if (!socket?.connected) {
    return false;
  }

  const requestId = crypto.randomUUID();

  activeRequests.add(requestId);

  try {

    // =========================
    // LOADING
    // =========================

    setLoadingDrivers(true);

    setLoadingFooter(true);

    setLoadingFooterTxt('Carregando motoristas...');

    setLoadProgress(0);

    // =========================
    // REQUEST
    // =========================

    await emitAsync(
      socket,
      'drivers:get',
      {
        requestId
      }
    );

    return true;

  } catch (err) {

    console.error(
      'Erro ao iniciar carregamento de motoristas:',
      err
    );

    finishDriversRequest(requestId);

    return false;

  }

}

// =========================
// REQUEST ATIVA
// =========================

export function isDriversRequestActive(
  requestId
) {

  return activeRequests.has(
    requestId
  );

}

// =========================
// FINALIZA REQUEST
// =========================

export function finishDriversRequest(
  requestId
) {

  activeRequests.delete(
    requestId
  );

  if (activeRequests.size > 0) {
    return;
  }

  setLoadingDrivers(false);

  setLoadingFooter(false);

  setLoadingFooterTxt( 'Carregando...');

  setLoadProgress(100);

}

// =========================
// LIMPA REQUESTS
// =========================

export function clearDriversRequests() {

  activeRequests.clear();

  setLoadingDrivers(false);

  setLoadingFooter(false);

  setLoadingFooterTxt('Carregando...');

  setLoadProgress(100);

}